<template>
  <div class="customize_container">
    <div class="customize_title">
      <!-- <div class="step">Step 3</div> -->
      <div class="step_title">選擇你想要的文字</div>
    </div>
    <div class="center">
      <div class="customize_step3">
        <form>
          <div>
            <div class="form-title-container">
              <p>{{isMedals?"祝賀詞與名稱":"宮廟名"}}</p>
              <div class="templeNameLimit">
                <span>{{templeNameLength}}</span>
                <span>/</span>
                <span>{{templeNameLimit}}</span>
              </div>
            </div>
            <input id="templeNameInput" type="text" :placeholder="isMedals?'例：恭祝 ＯＯＯ 生日快樂':'例:天后宮'" v-model="text.templeName">
          </div>
          <div>
            <div class="form-title-container">
              <p>{{isMedals?"祝賀詞":"神明名"}}</p>
              <div class="godNameLimit">
                <span>{{godNameLength}}</span>
                <span>/</span>
                <span>{{godNameLimit}}</span>
              </div>
            </div>
            <input id="godNameInput" type="text" :placeholder="isMedals?'例：鵬程萬里 心想事成':'例:天上聖母'" v-model="text.godName">
          </div>
          <div>
            <div class="form-title-container">
              <p>贈送人姓名（也可加上甲子年號、日期）</p>
              <div class="giftLimit">
                <span>{{giftLength}}</span>
                <span>/</span>
                <span>{{giftLimit}}</span>
              </div>
            </div>
            <input id="giftInput" type="text" placeholder="例:王大明 乙亥年" v-model="text.gift">
          </div>
          <div class="dropdown_title">
            <p class="title">{{isMedals?"贈詞":"敬獻辭"}}</p>
            <a href="#" v-on:click.prevent="showDropDown=!showDropDown">
              <div class="title title-color" v-if=!isRespect>請選擇{{isMedals?"贈詞":"敬獻詞"}}</div>
              <div class="title" v-else>{{text.respect}}</div>
              <i :class="{ 'fa-caret-up': showDropDown, 'fa-caret-down': !showDropDown }" class="fa" aria-hidden="true"></i>
            </a>
            <transition name="slide-fade">
              <div class="choice" v-if="showDropDown">
                <ul>
                  <li v-for="(link,index) in links" :key="index">
                    <span v-on:click="updateRespect(link)">{{link}}</span>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
          <!-- <p class="note">示意圖的字型、位置會再經過師傅專業編排，如換行斷字有特殊要求者，可以於商品備注中標示。</p> -->
          <!-- <p class="note">畫面呈現為示意圖，非正式製作的稿件。請加入官方 Line@，後台會將製作的稿件傳送給您，做最後確認！</p> -->
          <p class="note">畫面呈現為示意圖，正式製作稿件將由專業人員編排製版完成。</p>
        </form>
      </div>
      <div class="pic_changed">
        <div class="customProduct" ref="printMe">
          <component :is="displayComponentName"></component>
        </div>
      </div>
    </div>
    <!-- 此處用 back 是因為上一步可能回到 step 2 或 customize_gift -->
    <StepPreNext
     @preClick="back"
     @nextClick="$router.push({ name: 'customize_step4' })"
    ></StepPreNext>
  </div>
</template>

<script>
import customizeMetalA from "@/components/customize/customize_metalA.vue";
import customizeMetalB from "@/components/customize/customize_metalB.vue";
import customizeMetalC from "@/components/customize/customize_metalC.vue";
import customizeMetalD from "@/components/customize/customize_metalD.vue";
import customizeMetalE from "@/components/customize/customize_metalE.vue";
import customizeMetalF from "@/components/customize/customize_metalF.vue";
import customizeMetalG from "@/components/customize/customize_metalG.vue";
import customizeMetalH from "@/components/customize/customize_metalH.vue";
import customizeMetalI from "@/components/customize/customize_metalI.vue";
import customizeMetalJ from "@/components/customize/customize_metalJ.vue";
import customizeMetalK from "@/components/customize/customize_metalK.vue";
import customizeMetalL from "@/components/customize/customize_metalL.vue";
import customizeMetalM from "@/components/customize/customize_metalM.vue";
import customizeMetalN from "@/components/customize/customize_metalN.vue";
import customizeMetalO from "@/components/customize/customize_metalO.vue";
import customizeMetalP from "@/components/customize/customize_metalP.vue";
import customizeMetalQ from "@/components/customize/customize_metalQ.vue";
import customizeMetalR from "@/components/customize/customize_metalR.vue";
import customizeMetalS from "@/components/customize/customize_metalS.vue";
import customizeMetalT from "@/components/customize/customize_metalT.vue";
import customizeMetalU from "@/components/customize/customize_metalU.vue";
import customizeMetalV from "@/components/customize/customize_metalV.vue";
import customizeMetalW from "@/components/customize/customize_metalW.vue";
import customizeMetalX from "@/components/customize/customize_metalX.vue";
import customizeMetalY from "@/components/customize/customize_metalY.vue";
import customizeMetalZ from "@/components/customize/customize_metalZ.vue";
import customizeMetalAA from "@/components/customize/customize_metalAA.vue";
import customizeMetalAB from "@/components/customize/customize_metalAB.vue";
import customizeMetalAC from "@/components/customize/customize_metalAC.vue";
import customizeMetalZA from "@/components/customize/customize_metalZA.vue";
import customizeMetalAD from "@/components/customize/customize_metalAD.vue";
import customizeMetalAE from "@/components/customize/customize_metalAE.vue";
import customizeMetalAH from "@/components/customize/customize_metalAH.vue";
import customizeMetalAI from "@/components/customize/customize_metalAI.vue";
import customizeMetalAJ from "@/components/customize/customize_metalAJ.vue";
import customizeMetalAK from "@/components/customize/customize_metalAK.vue";
import customizeMetalAL from "@/components/customize/customize_metalAL.vue";
import customizeMetalAM from "@/components/customize/customize_metalAM.vue";
import customizeMetalAN from "@/components/customize/customize_metalAN.vue";
import customizeMetalAO from "@/components/customize/customize_metalAO.vue";
import customizeMetalAP from "@/components/customize/customize_metalAP.vue";
import customizeMetalAQ from "@/components/customize/customize_metalAQ.vue";
import customizeMetalAR from "@/components/customize/customize_metalAR.vue";
import customizeMetalAS from "@/components/customize/customize_metalAS.vue";
import customizeMetalAT from "@/components/customize/customize_metalAT.vue";
import customizeMetalAU from "@/components/customize/customize_metalAU.vue";
import StepPreNext from "@/components/StepPreNext.vue";

export default {
  name: "customizeStep3",
  components: {
    StepPreNext,
    customizeMetalA,
    customizeMetalB,
    customizeMetalC,
    customizeMetalD,
    customizeMetalE,
    customizeMetalF,
    customizeMetalG,
    customizeMetalH,
    customizeMetalI,
    customizeMetalJ,
    customizeMetalK,
    customizeMetalL,
    customizeMetalM,
    customizeMetalN,
    customizeMetalO,
    customizeMetalP,
    customizeMetalQ,
    customizeMetalR,
    customizeMetalS,
    customizeMetalT,
    customizeMetalU,
    customizeMetalV,
    customizeMetalW,
    customizeMetalX,
    customizeMetalY,
    customizeMetalZ,
    customizeMetalAA,
    customizeMetalAB,
    customizeMetalAC,
    customizeMetalZA,
    customizeMetalAD,
    customizeMetalAE,
    customizeMetalAH,
    customizeMetalAI,
    customizeMetalAJ,
    customizeMetalAK,
    customizeMetalAL,
    customizeMetalAM,
    customizeMetalAN,
    customizeMetalAO,
    customizeMetalAP,
    customizeMetalAQ,
    customizeMetalAR,
    customizeMetalAS,
    customizeMetalAT,
    customizeMetalAU
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      vm.fromRoute = from.name;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "customize_step4") {
      let checkoutTextLimitResult = this.checkoutTextLimit();
      if (checkoutTextLimitResult == "over") {
        alert("請輸入字數限制內的文字");
        next(false);
        return;
      }
      this.removeBorder();
      this.saveToImg();
      this.$store.dispatch("setIsGoToStep3", true);
      next();
    } else {
      next();
    }
  },
  created() {
    this.text = this.$store.getters.currentCustom.text;
    let componentCode = this.$store.getters.getComponentCode;
    this.displayComponentName = "customizeMetal" + componentCode;
    //取得字數限制並整理
    let textLimit = this.$store.getters.textSettingByComponentCode(
      componentCode
    );
    this.templeNameLimit =
      textLimit.templeName.lineLimit * textLimit.templeName.textLimit;
    this.godNameLimit =
      textLimit.godName.lineLimit * textLimit.godName.textLimit;
    this.giftLimit = textLimit.gift.lineLimit * textLimit.gift.textLimit;
  },
  data() {
    return {
      showDropDown: false,
      text: {
        templeName: "",
        godName: "",
        gift: "",
        respect: ""
      },
      displayComponentName: "customizeMetalA",
      templeNameLimit: "",
      templeNameLength: 0,
      godNameLimit: "",
      godNameLength: 0,
      giftLimit: "",
      giftLength: 0,
      fromRoute: ""
    };
  },
  watch: {
    "text.templeName"(newText) {
      if (newText.length >= parseInt(this.templeNameLimit)) {
        let templeNameLimit = document.querySelector(".templeNameLimit");
        templeNameLimit.style.color = "red";
      } else {
        let templeNameLimit = document.querySelector(".templeNameLimit");
        templeNameLimit.style.color = "#4a4a4a";
      }
      this.templeNameLength = newText.length;
      this.updateCostom();
    },
    "text.godName"(newText) {
      if (newText.length >= parseInt(this.godNameLimit)) {
        let godNameLimit = document.querySelector(".godNameLimit");
        godNameLimit.style.color = "red";
      } else {
        let godNameLimit = document.querySelector(".godNameLimit");
        godNameLimit.style.color = "#4a4a4a";
      }
      this.godNameLength = newText.length;
      this.updateCostom();
    },
    "text.gift"(newText) {
      if (newText.length >= parseInt(this.giftLimit)) {
        let giftLimit = document.querySelector(".giftLimit");
        giftLimit.style.color = "red";
      } else {
        let giftLimit = document.querySelector(".giftLimit");
        giftLimit.style.color = "#4a4a4a";
      }
      this.giftLength = newText.length;
      this.updateCostom();
    }
  },
  methods: {
    updateCostom() {
      let payload = {
        key: "text",
        content: this.text
      };
      this.$store.dispatch("updateCostom", payload);
    },
    updateRespect(item) {
      this.text.respect = item;
      this.updateCostom();
      this.showDropDown = false;
    },
    async saveToImg() {
      let canvasData = "";
      const el = this.$refs.printMe;
      canvasData = await this.$html2canvas(el, { backgroundColor: null });
      this.$store.dispatch("updataCanvasDataUrl", canvasData.toDataURL());
    },
    removeBorder() {
      var templeName = document.querySelector(".templeName");
      var gift = document.querySelector(".gift");
      templeName.style.border = "none";
      gift.style.border = "none";
      if (this.$store.getters.getComponentCode == "J") {
        var godNamefirst = document.querySelector(".godName-first");
        godNamefirst.style.border = "none";
        var godNamelast = document.querySelector(".godName-last");
        godNamelast.style.border = "none";
      } else {
        var godName = document.querySelector(".godName");
        godName.style.border = "none";
      }
    },
    checkoutTextLimit() {
      if (this.text.templeName.length > this.templeNameLimit) {
        return "over";
      } else if (this.text.godName.length > this.godNameLimit) {
        return "over";
      } else if (this.text.gift.length > this.giftLimit) {
        return "over";
      } else {
        return "ok";
      }
    },
    back() {
      if (this.fromRoute === "customize_fan") {
        this.$router.push({ name: "customize_fan" });
      } else if (this.fromRoute === "customize_gift") {
        this.$router.push({ name: "customize_gift" });
      } else {
        this.$router.push({ name: "customize_step2" });
      }
    }
  },
  computed: {
    isRespect() {
      return this.text.respect;
    },
    isMedals() {
      return this.$store.getters.isMedalsLabelDisplay;
    },
    links() {
      if (this.isMedals) {
        return ["賀", "同賀", "敬賀", "恭賀", "贈", "同贈", "敬贈"];
      } else {
        return ["敬賀", "恭賀", "祝賀", "敬獻", "喜獻", "叩敬", "敬謝", "叩謝"];
      }
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.customize_container {
  position: relative;
  margin-top: 30px;
  margin-bottom: 60px;
  /deep/ .step-pre-next {
    @include table {
      top: 360px;
    }
  }
}
.customize_title {
  color: $primaryDeepColor;
  font-size: 24px;
  font-family: "NotoSerifTC-Bold";
}
.center {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 30px 120px;
  z-index: 99;
  position: relative;
  @media all and (min-width: 1440px) {
    margin: 30px 8.3%;
  }
  @include table {
    grid-template-columns: 1fr;
    z-index: 1;
  }
  @include betweenPhoneTable {
    margin: 30px 0px;
  }
}
.customize_step3 {
  color: $secondaryDeepColor1;
  font-size: 17px;
  text-align: left;
  padding-left: 50px;
  margin: 0 auto;
  p,
  input {
    max-width: 405px;
    width: 100%;
  }
  input {
    height: 55px;
    border-radius: 2px;
    border: 1px $primaryDeepColor solid;
    padding-left: 10px;
    background-color: #fefff9;
    color: $secondaryDeepColor1;
    font-size: 17px;
  }
  input::placeholder {
    color: $secondaryLightColor1;
  }
  @include tablePro {
    padding-left: 20px;
  }
  @include betweenTableTablePro {
    padding-left: 0px;
  }
  @include table {
    order: 2;
  }
  @include betweenPhoneTable {
    padding: 0 20px;
  }
}
.pic_changed {
  width: 500px;
  margin-bottom: 30px;
  padding: 0 10px;
  div {
    width: 500px;
    height: 400px;
    object-fit: contain;
  }
  @include betweenTableTablePro {
    width: 400px;
    div {
      width: 400px;
      height: 320px;
      object-fit: contain;
    }
  }
  @include table {
    order: 1;
    width: 350px;
    justify-self: center;
    margin-bottom: 115px;
    padding: 0px;
    div {
      width: 350px;
      height: 280px;
      object-fit: contain;
    }
  }
  @include phone {
    width: 320px;
    margin-bottom: 150px;
    div {
      width: 320px;
      height: 256px;
      object-fit: contain;
    }
  }
}
.form-title-container {
  display: flex;
  justify-content: space-between;
  margin: 17px 0;
  p {
    margin: 0;
  }
}
.note {
  color: $secondaryColor2;
}
//dropdown
.dropdown_title {
  position: relative;
  a,
  span {
    color: $secondaryDeepColor1;
    text-decoration: none;
    display: flex;
    align-items: center;
    border: 1px $primaryDeepColor solid;
    background-color: #fefff9;
    padding: 15px 15px 15px 10px;
    max-width: 405px;
    width: 100%;
  }
  span:hover {
    color: $secondaryColor3;
    background-color: $primaryLightColor;
  }
  .title-color {
    color: $secondaryLightColor1;
  }
}

ul {
  display: block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.choice {
  position: absolute;
  width: 100%;
  max-height: 155px;
  overflow: scroll;
}

.fa {
  margin-left: auto;
  color: $primaryLightColor;
}
</style>
